// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainDialog {
  display: flex;
  flex-direction: column;
  padding: 1rem;
  min-width: 320px;
}

.header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.rowContainer {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem;
}

.fileContainer {
  display: flex;
  background-color: #FF6B00;
  border-radius: 0.6rem;
  color: white;
  cursor: pointer;
  gap: 0.2rem;
  padding: 0.6rem 1rem;
}

.accordingList ul {
  padding: 0;
  margin-right: 1rem;
  line-height: 1.75rem;
  font-size: 0.875rem;
}`, "",{"version":3,"sources":["webpack://./src/components/UserManagement/Add/add.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;AACJ;;AAEA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AACJ;;AAEA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AACJ;;AAEA;EACI,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,oBAAA;AACJ;;AAGI;EACI,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;AAAR","sourcesContent":[".mainDialog {\n    display: flex;\n    flex-direction: column;\n    padding: 1rem;\n    min-width: 320px;\n}\n\n.header {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.rowContainer {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0.5rem;\n}\n\n.fileContainer {\n    display: flex;\n    background-color: #FF6B00;\n    border-radius: 0.6rem;\n    color: white;\n    cursor: pointer;\n    gap: 0.2rem;\n    padding: 0.6rem 1rem;\n}\n\n.accordingList {\n    ul {\n        padding: 0;\n        margin-right: 1rem;\n        line-height: 1.75rem;\n        font-size: 0.875rem;\n        li {\n            //list-style: none;\n\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
